import {
  LOGIN_USER,
  LOGOUT_USER
} from 'constants/actionTypes'

const INIT_STATE = {}

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case LOGIN_USER:
      return {
        ...state,
        authenticated: true
      }
    case LOGOUT_USER:
      return { ...state, authenticated: false }
    default:
      return { ...state }
  }
}



// WEBPACK FOOTER //
// ./reducers/auth.js